import { isNativePlatform } from 'components/helper/Platform';
import { LoginButtonProps } from 'components/molecules/LoginButton/LoginButton.types';
import * as React from 'react';
import { LoginButtonNative } from './LoginButtonNative';
import { LoginButtonWeb } from './LoginButtonWeb';

function LoginButton(props: LoginButtonProps) {
	if (isNativePlatform()) {
		return <LoginButtonNative {...props} />;
	}
	return <LoginButtonWeb {...props} />;
}

export default LoginButton;
